exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* :host /deep/ lets shadowdom style child elements */\n:host /deep/ {\n  /**\n    * CSS Overrides for bug fixes\n    */\n  /**\n    * END CSS Overrides for bug fixes\n    */\n  /* Manage list custom styles */ }\n  :host /deep/ .md-sort-item /deep/ .md-list-item-content {\n    padding: 0; }\n  :host /deep/ .md-sort-icon {\n    font-size: 15px;\n    margin-right: 10px; }\n  :host /deep/ .md-sort-header {\n    padding: 10px; }\n    :host /deep/ .md-sort-header:hover {\n      background-color: #EEEEEE;\n      cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 0